<template>
  <div class="user-center__case-container user-center__common-child-container">
    <SubPageHeader>
      <template #title>
        <router-link
          tag="div"
          :to="nav.url"
          active-class="active"
          class="title__front-item"
          v-for="(nav, index) in breadcrumbs"
          :key="index"
        >{{ nav.name }}</router-link>
      </template>
      <template #bt>
        <router-link
          tag="div"
          :to="{
            path: btShow.url
          }"
          class="bt-item"
        >{{ btShow.text }}</router-link>
      </template>
    </SubPageHeader>
    <div class="case__main-body">
      <router-view :key="$route.fullpath" class="common-user-case-list-container"></router-view>
    </div>
    <!-- 弹出反馈 -->
    <el-dialog
      custom-class="proposal-dialog"
      title="反馈"
      :visible.sync="replyVisible"
      :close-on-click-modal="false"
    >
      <div class="detail__reply-form requirement-reply-form dialog-reply-form">
        <el-form :model="form" class="requirement-reply-form" :rules="rules" ref="replyForm">
          <el-form-item class prop="title">
            <el-input v-model="form.title" placeholder="标题" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item class="form__textarea" prop="content">
            <el-input placeholder="反馈内容" type="textarea" v-model="form.content"></el-input>
          </el-form-item>
          <div class="form__bts-proposal">
            <el-button :loading="loading" class="form__submit bt__item" @click="onReply">反馈</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SubPageHeader from "../_pageHeader.vue";
import { addProposal } from "@/api/designStore";
export default {
  components: {
    SubPageHeader
  },
  data() {
    return {
      breadcrumbs: [
        {
          name: "推荐案例",
          url: "/my/recommendCase"
        }
      ],
      replyVisible: false,
      form: {
        title: "",
        content: ""
        // picture_ids: [],
        // picture_urls: [],
      },
      rules: {
        title: [
          {
            required: true,
            message: "请填写标题",
            trigger: "change"
          }
        ],
        content: [
          {
            required: true,
            message: "请填写反馈内容",
            trigger: "change"
          }
        ],
        picture_ids: [
          {
            required: true,
            message: "请上传图片",
            trigger: "change"
          }
        ]
      },
      loading: false,
      fileList: [],
      fileLimt: 9,
      btShow: {
        text: "发布案例",
        url: "/my/case/create"
      }
    };
  },
  watch: {
    $route: "init"
  },
  created() {
    // console.log('dynamic index created');
  },
  methods: {
    init(val) {
      console.log(val);
      console.log("recommendStore index init");
    },
    onReply() {
      this.$refs.replyForm.validate(valid => {
        if (valid) {
          this.loading = true;
          addProposal(this.form)
            .then(res => {
              this.loading = false;
              this.replyVisible = false;
              this.$message({
                type: "success",
                message: "反馈成功"
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="scss">
.user-center__case-container {
  .bt-item-recommendStore {
    cursor: pointer;
    text-decoration: underline;
  }
}
.proposal-dialog {
  .form__bts-proposal {
    text-align: center;
    margin-top: 20px;
    button {
      color: #0080da !important;
      padding: 6px 10px !important;
    }
  }
  .el-input__inner {
    height: 30px !important;
  }
}
.v-modal {
  z-index: 0 !important;
}
</style>
